import { ApiInstance } from "utils/Api";

import type { LeadsNotSnoozedFilters } from "modules/LeadsDashboard/queryKeys";

export const exportLeadsNotSnoozed = async (filters: LeadsNotSnoozedFilters) => {
  await ApiInstance.post("/leads/export/not_snoozed/enqueue", filters);
};
